import aboutImage from "./about_image.jpg";
import React, { Component } from "react";

class AboutPage extends Component {
  componentWillMount = () => {
    console.log("Mounting About");
    this.props.setAppDefault();
  };

  componentDidMount = () => {
    window.scrollTo(-100, -100)
  }

  render() {
    return (

      <div
        className="flex-container"
        style={{
          display:
            this.props.appState.currentPage === "about" ? "block" : "none",
        }}
      >
        <div>
          <h3 className="text-center">Speech based Neuro-degenerative Diseases Monitoring</h3>
          <div className="text-justify ml-5 mr-5 mt-2 mb-4">
            One of the typical symptoms of neuro-degenerative diseases like Amyotrophic lateral sclerosis (ALS), Parkinson's disease (PD) and Alzheimer's disease is dysarthria, that is, difficulty in speech production. Dysarthria involves slurred/mumbled speech, too slow/fast speaking rate, very loud/soft speech, nasal, breathy and strained voice, long and frequent pauses. These impairments compromise the naturalness and often intelligibility of speech. The figure below shows speech waveforms and associated spectrograms for an ALS patient, a PD patient and a healthy individual. Each person is uttering the word ‘pa’ in succession. We can see that the speaking rate significantly reduces for the patients and the information content in the spectrogram gets confined to lower frequency regions. This project aims to identify and analyse such distinguishing patterns between dysarthric and healthy speech.
          </div>
          <div class="text-center">
            <img src={aboutImage} alt="about" height="300" width="500"></img>
          </div>
          <div className="text-left ml-5 mt-4">
            <b>Objectives:</b>
            <ul>
              <li>
                To detect neuro-degenerative diseases automatically at early stages using speech cues
              </li>
              <li>
                To monitor the severity and progression of the diseases using speech cues
              </li>
              <li>
                To enhance the naturalness and intelligibility of the dysarthric speech
              </li>
              <li>
                To understand and model the effects of these diseases on different parts of the speech production system
              </li>
              <li>
                To develop a mobile/web application that can assist neurologists in diagnosing the disease and monitoring its progression using speech as a biomarker 
              </li>
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

export default AboutPage;
